import {
  OPERATED_SCOPE,
  EQUITY_SCOPE,
  NET_ABSOLUTE_EMISSIONS,
  AVG_CARBON_INT,
  VOLUME_WEIGHTED_AVG_CARBON_INT,
  SCOPE3_CAT11_EMISSION,
} from '../api/constants';

export const pointzerofive = 0.05;
export const pointzerofour = 0.04;
export const PointTwoNineThree = 0.293;
export const point1 = 0.1;
export const pointtwo = 0.2;
export const pointthree = 0.3;
export const pointhreefour = 0.34;
export const pointthreenine = 0.39;
export const pointfour = 0.4;
export const pointfourfive = 0.45;
export const pointfive = 0.5;
export const pointfiveeight = 0.58;
export const pointsix = 0.6;
export const pointeight = 0.8;
export const pointnine = 0.9;
export const one = 1;
export const two = 2;
export const three = 3;
export const ThreePointSix = 3.6;
export const threepointfourone = 3.41;
export const four = 4;
export const five = 5;
export const six = 6;
export const seven = 7;
export const ten = 10;
export const twelve = 12;
export const twenty = 20;
export const thirty = 30;
export const thirtynine = 39;
export const forty = 40;
export const fortyone = 41;
export const fiftynine = 59;
export const fiftyeight = 58;
export const eighty = 80;
export const hundred = 100;
export const onefifty = 150;
export const onethirtynine = 139;
export const twohundred = 200;
export const fivehundres = 500;
export const twotwenty = 220;
export const twofifty = 250;
export const thousand = 1000;
export const thousandfivehundred = 1500;
export const fivethousand = 5000;
export const tenlakh = 1000000;
export const year2012 = 2012;
export const year2016 = 2016;
export const eigthteenPointFour = 18.4;
export const fiveHundreds = 500;
export const loginPageTitle =
  "Authenticate your account by logging into Shell's single sign-on provider.";
export const LOGOUT = 'logout';
export const TITLE_KPI_CALCULATOR = 'Carbon KPI Calculator';
export const SUB_TITLE_KPI_CALCULATOR = 'Shell Energy';
export const ALL_CARBON_DEALS_HEADING = 'All Deals';
export const DEAL_ENTRY_FORM_TAB = 'Deal Entry Form';
export const TABS_MENU = [
  {
    key: '0',
    path: '/kpi-calculator',
    label: DEAL_ENTRY_FORM_TAB,
  },
  {
    key: '1',
    path: '/all-deals',
    label: ALL_CARBON_DEALS_HEADING,
  },
];

export const ALL_CARBON_DEALS_SUMMARY =
  'Note: Carbon Emissions and Equity Scope 1 & 2 are shown in MTPA, and Margin to Carbon Ratio (MCR) is shown in $/tCO2e.';

export const fieldKeys = [
  'Operated Scope 1&2 (MTPA)',
  'Equity Scope 1&2 (MTPA)',
  'Net Absolute Emissions (MTPA)',
  'Avg Carbon Intensity**',
  'NCI Impact (gCO2e/MJ)',
];
export const dataKeys = [
  'OPERATED_SCOPE',
  'EQUITY_SCOPE',
  'CARBON_EMISSIONS',
  'CARBON_EMISSIONS',
  'CHANGED_REPORTED_GROUP_NCI',
];
// Field keys for T&S Products (display labels for the rows)
export const fieldKeys_TS = [
  'Operated Scope 1&2 (MTPA)',
  'Equity Scope 1&2 (MTPA)',
  'Net Absolute Emissions (MTPA)',
  'Volume-weighted Avg Carbon Intensity (gCO2e/MJ)',
  'Scope 3 Category 11 Emission (KTPA)',
  'NCI Impact (gCO2e/MJ)',
];
// Data keys for T&S Products (includes additional fields)
export const dataKeysSLMT_TS = [
  'OPERATED_SCOPE',
  'EQUITY_SCOPE',
  'CARBON_EMISSIONS',
  'VOLUME_WEIGHTED_AVG_CARBON_INT',
  'SCOPE3_CAT11_EMISSION',
  'CHANGED_REPORTED_GROUP_NCI',
];
export const DEAL_MODAL_TITLE = 'Confirm Delete';
export const DEAL_MODAL_SUBTITLE = 'Are you sure you want to delete the selected deals?';
export const DEAL_MODAL_WARNING =
  '** The deal will be archived in the system. It can be recovered later.';
export const DEAL_TYPE_LABEL = [
  'If you are using the KPI Calculator to test a deal, click Yes.',
  "If you are using the KPI Calculator to enter in the details of a 'live' deal being actively worked, click No.",
];
export const OPERATING_PLAN_LABEL = 'Is the deal included in OP?';
export const DEAL_SUPPORT_CONTACT = 'Please contact the Shell Energy Carbon Portfolio Team.';
export const TYPE_OF_DEAL_OPTIONS = [
  {
    value: one,
    label: 'Yes',
  },
  {
    value: 0,
    label: 'No',
  },
];

export const OPERATING_PLAN_OPTIONS = [
  {
    value: one,
    label: 'Yes',
  },
  {
    value: 0,
    label: 'No',
  },
  {
    value: two,
    label: 'Not Sure',
  },
];
export const nonConversionRequiredUOMs = ['mtco2e'];
export const pipeLineGas = 'Pipeline Gas';

// First column data for Step 03 KPI table - Standard EVPs (Shell Energy, DR Power, etc.)
export const FIRST_COL_DATA: string[] = [
  OPERATED_SCOPE,
  EQUITY_SCOPE,
  NET_ABSOLUTE_EMISSIONS,
  AVG_CARBON_INT,
];

// First column data for Step 03 KPI table - T&S Products EVP only
// T&S Products EVP requires additional KPIs per business specification
// For T&S Products, we use Volume-weighted Avg Carbon Intensity instead of regular Avg Carbon Intensity
// Note: SLMT uses standard KPI calculations (FIRST_COL_DATA) like other EVPs
export const FIRST_COL_DATA_SLMT_TS: string[] = [
  OPERATED_SCOPE,
  EQUITY_SCOPE,
  NET_ABSOLUTE_EMISSIONS,
  VOLUME_WEIGHTED_AVG_CARBON_INT, // Replaces AVG_CARBON_INT for T&S Products
  SCOPE3_CAT11_EMISSION, // Only for T&S Products
];
export const year2025 = 2025;
export const year2030 = 2030;
export const notAvailable = -9999;

export const dummyNciData = {
  CHANGED_GROUP_VOLUME: 0,
  CHANGED_NET_ABSOLUTE_EMISSIONS: 0,
  CHANGED_REPORTED_GROUP_NCI: 0,
  EMISSIONS: 0,
  EMISSIONS_UNIT: 'mtpa',
  GROUP_NCI_TARGET_HIGHER: 0,
  GROUP_NCI_TARGET_LOWER: 0,
  GROUP_NCI_TARGET_UNIT: 'gCO2e/MJ',
  GROUP_VOLUME: 0,
  GROUP_VOLUME_UNIT: 'mj',
  NET_ABSOLUTE_EMISSIONS: 0,
  NET_ABSOLUTE_EMISSIONS_UNIT: 'mtpa',
  OFFSETS: 0,
  OFFSETS_UNIT: 'mtpa',
  OPERATING_PLAN: 'OP24',
  REPORTED_GROUP_NCI: notAvailable,
  YEAR: 0,
};
